<div class="container limited mt-7">
  <div class="fullscreen-process">
    <div class="process-content">
      <mwe-bullet-confirmation-view
        successMsgKey="products-add.no-birthdate-in-sap.title"
        [bulletStateMap]="bulletStateMap"
        [bulletLabelMap]="bulletLabelMap"
        [bulletTitleMap]="bulletTitleMap"
        [bulletStateIconMap]="bulletStateIconMap"
        [bulletStateClassMap]="bulletStateClassMap"
        [bulletIds]="bulletIds"
        [state]="state"
        [isSuccessImageVisible]="true"
        [successImageSrc]="'link-product.svg' | addStaticImagePath"
      />
    </div>
  </div>
</div>
